const moneyFormat = $('body').data('money-format');
const formatMoney = window.Shopify.formatMoney;
$(document).ready(function(){
  updateStepCount();
}); //ready

$(document).on('click', function(e) {
  if (e.target.id === 'customize_modal--alert' || e.target.closest('#popup-close')) {
    alertPopup();
  }
});

$(document).on('click', '.engrav_acc_btn', function(){
  const target = $(this).attr('data-target');
  $('.engrave_acc_content').hide();
  $('.engrav_acc_btn').removeClass('active').addClass('secondary');
  $(target).show()
  $(this).addClass('active').removeClass('secondary');
});


$(document).on('click', '.tooltip_icon__wrap', function(){
  const mgs = $(this).attr('data-content');
  const title = $(this).attr('data-title');
  alertPopup(mgs, title);
});


$(document).on('change', '.step--js', function() {
  const $el = $(this);
  const stepName = $el.attr('name');
  const val = $el.val();

  switch (stepName) {
    case 'step_1':
      const isGift = isGiftSelected();
        $('.stap_5_fields').toggle(isGift);
        $('[name="step_5"][value="1"]').closest('label[for]').toggle(!isGift);
        if(isGift) {
          $('[name="step_5"][value="2"]').click();
          $('[name="step_5_1"][value="2"]').click();
        } else {
          $('[name="step_5"][value="1"]').click();
          $('[name="step_5_1"][value="1"]').click();
        }
      break;

    case 'step_2':
      const skipStep = $el.attr('data-skip') === 'true';
      $('.stepp_8').toggle(!skipStep);
      const product = $el.data('product');
      if (product?.variants) {
        $('[data-step3-markup-container]').html(generateStep3Markup(product.variants));
        const len = $('[data-step3-markup-container]').find('.step_3_list_item').length || 0;
        $('.stepp_3').toggle(len > 1);
      }
      break;

    case 'step_5':
      $('.step_5_1_list').toggle(val == '2');
      break;
    default:
      // console.warn('Unhandled step:', stepName);
  }
  totalPrice();
  updateStepCount();
});

$(document).on('input', '.engrave--js', totalPrice);


$(document).on('change', '.variant-pick', function () {
  const $el = $(this);
  const $wrap = $el.closest('.step_wrapper');
  const $input = $wrap.find('.step--js');
  const $configPrice = $wrap.find('.config_price');
  const $configCPrice = $wrap.find('.config_cprice');
  const $img = $wrap.find('.product_item_image_wrap img');
  let variant;
  try {
    variant = JSON.parse($el.val());
  } catch (err) {
    console.error('Invalid variant JSON:', $el.val());
    return;
  }
  if (variant.compare_at_price > variant.price) {
    $configCPrice.html(formatMoney(variant.compare_at_price, moneyFormat));
  } else {
    $configCPrice.empty();
  }
  $configPrice.html(formatMoney(variant.price, moneyFormat));
  $input.attr('data-variant', $el.val());
  console.log(variant)
  totalPrice();

  if (variant?.featured_image?.src) {
    const imageBaseUrl = variant.featured_image.src;
    const newSrc = `${imageBaseUrl}?width=300`;
    const newSrcset = `
      ${imageBaseUrl}?width=100 100w,
      ${imageBaseUrl}?width=200 200w,
      ${imageBaseUrl}?width=300 300w
    `.trim();

    $img.attr({
      src: newSrc,
      srcset: newSrcset
    });
 }
});


// $(document).on('click', '.sticky_atc_btn', function(){
//   const isGift = isGiftSelected();
//   const validate = inputValidate();
//   if(!validate) return;
//   $(this).addClass('btn-loading');
//   const shippingInsurancePrice = data.find(item => Number(item.shipping_insurance_price) > 0)?.shipping_insurance_price || 0;
//   if(shippingInsurancePrice) {

//   }
//   multipleATC(window.payload_data, $(this));
// });

$(document).on('click', '.sticky_atc_btn', async function() {
  const isGift = isGiftSelected();
  const validate = inputValidate();
  if (!validate) return;

  $(this).addClass('btn-loading');
  const shippingIns = window.payload_data.find(item => Number(item.shipping_insurance_price) > 0);
  const shippingInsurancePrice = shippingIns?.shipping_insurance_price || 0;
  if (shippingInsurancePrice) {
    try {
      const result = await callShippingInsuranceAPI(shippingInsurancePrice);
      const ins_v = result.product.variant;
      console.log('Shipping insurance added successfully >>', result, ins_v);
      if(ins_v) {
        window.payload_data.push({
          id: Number(ins_v.id.split("gid://shopify/ProductVariant/").pop()),
          quantity: 1,
          selling_plan: null,
          properties: {"__shipping_insurance_apply_for": shippingIns.id}
        });
      }
    } catch (err) {
      console.log('Error adding shipping insurance:', err);
    }
  }

  multipleATC(window.payload_data, $(this));
});



async function callShippingInsuranceAPI(shippingInsurancePrice) {
  const title = `Shipping Insurance - ${shippingInsurancePrice}`;
  const APP_URL = "https://prurmore-product-insurance-8236b6ba3426.herokuapp.com";
  const body = {
    title,
    imageUrl: "https://cdn.shopify.com/s/files/1/0126/5647/6250/files/Gemini_Generated_Image_bsoxo8bsoxo8bsox_1.jpg?v=1761913385",
    price: shippingInsurancePrice,
    description: "**⚠️ Please do NOT delete this product — it was created automatically by the app.**",
    sku: `INS-${shippingInsurancePrice}`
  };

  try {
    const response = await fetch(`${APP_URL}/api/create-product`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API error (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    console.log("✅ Shipping insurance product created:", data);
    return data;
  } catch (error) {
    console.error("❌ Failed to create shipping insurance product:", error);
    throw error;
  }
}


function alertPopup(message='', title='') {
  if(message || message != ''){
    $('#customize_modal--alert [popup-message--container]').html(message);
    $('#customize_modal--alert').addClass('opened').show();
    $('body').addClass('modal-opened');
    if(title != '') {
      $('#customize_modal--alert .popup-title').html(title).removeClass('no-title')
    } else {
      $('#customize_modal--alert .popup-title').html('').addClass('no-title')
    }
  } else {
    $('#customize_modal--alert .popup-title').html('').removeClass('no-title')
    $('#customize_modal--alert [popup-message--container]').html('');
    $('#customize_modal--alert').removeClass('opened').hide();
    $('body').removeClass('modal-opened'); 
    $('body').removeClass('table_content_wrap');
  }
}

function generateStep3Markup(variants) {
  return variants.map((variant, i) => {
    const isChecked = i === 0 ? 'checked' : '';
    const imageMarkup = window.step_2_images[i]
      ? `<img 
            src="${window.step_2_images[i]}" 
            width="100%" height="auto" 
            class="item_image thumbnail" 
            loading="lazy"
            style="width: auto; object-fit: contain; height: 80px;"
         >`
      : generateFallbackImages(i);

    return `
      <label for="step_3_${i}" class="cursor-pointer rounded step_3_list_item flex_item">
        <input 
          class="hidden step--js" 
          id="step_3_${i}" 
          type="radio" 
          name="step_3" 
          value="${variant.title || ''}" 
          ${isChecked}
        >
        <div class="thumbnail_item flex flex-col gap-2">
          ${imageMarkup}
          <div class="text-base item_title text-center box">
            ${variant.title || ''}
          </div>
          <div class="item_shipiment text-center">
            <div class="text-lg" data-price>${formatMoney(variant.price, moneyFormat)}</div>
            <div class="text-sm">Per Shipment</div>
          </div>
          <div class="text-sm item_info text-center">
            ${variant.info || ''}
          </div>
          <label for="step_3_${i}" class="btn-select cursor-pointer rounded global-button text-center"> Select </label>
        </div>
      </label>
    `;
  }).join('\n');
}

function generateFallbackImages(index) {
  let markup = `
    <div class="imggg_box flex items-center mb-4 justify-center">
      <img
        class="glass-icon"
        loading="lazy"
        width="auto"
        height="auto"
        src="//pourmore.com/cdn/shop/files/icon-glass_small.png?v=1637171258"
      >`;

  if (index === 1 || index === 2) {
    markup += `
      <img
        class="arrow-icon"
        loading="lazy"
        width="auto"
        height="auto"
        src="//pourmore.com/cdn/shop/files/up-right-arrow_2_small.png?v=1637171834"
      >
      <img
        class="glass-icon-1"
        loading="lazy"
        width="auto"
        height="auto"
        src="//pourmore.com/cdn/shop/files/icon-glass_small.png?v=1637171258"
      >`;
  }

  if (index === 2) {
    markup += `
      <img
        class="arrow-icon-1"
        loading="lazy"
        width="auto"
        height="auto"
        src="//pourmore.com/cdn/shop/files/up-right-arrow_2_small.png?v=1637171834"
      >
      <img
        class="glass-icon-2"
        loading="lazy"
        width="auto"
        height="auto"
        src="//pourmore.com/cdn/shop/files/icon-glass_small.png?v=1637171258"
      >`;
  }

  markup += `</div>`;
  return markup;
}

function searchVariant() {
  const selectedProductData = $('[name="step_2"]:checked').data('product');
  if (!selectedProductData) return {};

  const productTitle = selectedProductData.title;
  const variantTitle = $('[name="step_3"]:checked').val();
  const step4Val = $('[name="step_4"]:checked').val();
  const step5Val = $('[name="step_5"]:checked').val();
  const step5_1Val = $('[name="step_5_1"]:checked').val();

  const delFreq = step4Val === '2' ? 'bi_monthly' : 'monthly';
  const normalizedTitle = productTitle.toLowerCase() === 'rosé' ? 'rose' : productTitle.toLowerCase();
  const isGift = isGiftSelected();

  const subsLen =
    step5Val === '1' ? 'month_1' :
    step5_1Val === '1' ? 'month_3' :
    step5_1Val === '3' ? 'month_12' :
    'month_6';

  const productList = window.subscription_box?.[delFreq] || {};
  const newP = {};

  for (let key in productList) {
    newP[key] = productList[key]
      .filter(product => product.handle.toLowerCase().includes(normalizedTitle))
      .flatMap(product => product.variants)
      .find(variant => {
        const name = variant.name?.toLowerCase() || '';
        const isTitleMatch = variant.title === variantTitle;
        const isGiftMatch = isGift ? name.includes('gift') : !name.includes('gift');
        return isTitleMatch && isGiftMatch;
      });
  }
  console.log({productTitle,variantTitle,step4Val,step5Val,step5_1Val,delFreq,normalizedTitle,isGift,subsLen,productList,newP}, "<<<<searchVariantData");
  freqPriceUpdate(newP);
  return newP[subsLen] || {};
}

function freqPriceUpdate(variants) {
  $('.step_5_1_list_item').removeAttr('data-save');
  $('[freq-obj]').each(function () {
    const $el = $(this);
    const obj = $el.attr('freq-obj');
    const variant = variants[obj];

    if (variant?.price) {
      const { price, compare_at_price } = variant;
      
      const isDiscounted = compare_at_price > price;
      const savedPercent = isDiscounted
        ? Math.round(((compare_at_price - price) / compare_at_price) * 100)
        : 0;

      const comparePriceMarkup = isDiscounted
        ? `<span class="config_cprice">${formatMoney(compare_at_price, moneyFormat)}</span>`
        : '';

      const savePercentMarkup = isDiscounted
        ? `Save ${savedPercent}%`
        : '';

      const markup = `
        <div class="item_price text-center">
          <span class="config_price">${formatMoney(price, moneyFormat)}</span>
          ${comparePriceMarkup}
        </div>
      `;

      $el.html(markup);
      if(savePercentMarkup != '') {
        $el.closest('.step_5_1_list_item').attr('data-save', savePercentMarkup);
      }
    }
  });
}

function totalPrice() {
  const v1 = searchVariant();
  if (!v1?.id) {return;}
  const p1 = v1?.price || 0;
  const shipping_insurance_price = p1 * 3 / 100;
  const cp1 =  compare_at_price(v1);
  const isGift = isGiftSelected();
  let data = [], props = {}, p2 = 0,
   p3 = 0, p4 = 0, cp2 = 0, cp3 = 0, cp4 = 0, v3 = null,
   $btn = $('.sticky_atc_btn'),
    $p = $('.s_price')
    $cp = $('.s_cprice');

  const v2 = $('[name="step_6"]:checked').data('variant') || null;
  p2 = v2?.price || 0;
  cp2 = compare_at_price(v2);

  try { 
    const p3_variant = $('[name="step_7"]:checked').attr('data-variant');
    if (p3_variant) {
      v3 = JSON.parse(p3_variant); 
      p3 = v3?.price || 0;
      cp3 = compare_at_price(v3);
    }
  } catch {}
  // const v3 = $('[name="step_7"]:checked').data('variant') || null;
  // p3 = v3?.price || 0;
  // cp3 = compare_at_price(v3);

  const v4 = $('.stepp_8').data('variant') || null;

  const engraves = $('.engrave--js').filter((_, el) => $(el).val() !== "");
  if (engraves.length && v4?.id) {
    p4 = v4?.price || 0;
    cp4 = compare_at_price(v4);
    const engrave_props = {"Choosed Club Name": v1?.name};
    engraves.each((_, el) => {
      const $el = $(el);
      const name = $el.attr('name')?.trim();
      const value = $el.val()?.trim();
      if (name && value) {
        engrave_props[name] = value;
      }
    });
    data.push({
      id: v4.id,
      quantity: 1,
      selling_plan: v4?.selling_plan_allocations?.length ? v4.selling_plan_allocations[0].selling_plan_id : null,
      properties: engrave_props
    });
  }

  const total = p1 + p2 + p3 + p4;
  const ctotal = cp1 + cp2 + cp3 + cp4;
  $p.html(formatMoney(total, moneyFormat));
  $cp.html(formatMoney(ctotal, moneyFormat));
  const enabled = total > 0;
  $btn.prop('disabled', !enabled)
      .toggleClass('opacity-100', enabled)
      .toggleClass('opacity-50', !enabled);
  $p.toggleClass('opacity-100', enabled)
    .toggleClass('opacity-50', !enabled);
  $cp.toggleClass('opacity-100', enabled)
    .toggleClass('opacity-50', !enabled)
    .toggleClass('hidden', ctotal <= total);
  if(isGift) {
    props = {
      "Recipient name": $('#config_rec_name').val(),
      "Email": $('#config_email').val(),
      "Gift Note": $('#config_gift_note').val()
    }
  }

  data.push({
    id: v1.id,
    quantity: 1,
    selling_plan: v1?.selling_plan_allocations?.length ? v1.selling_plan_allocations[0].selling_plan_id : null,
    properties: props,
    shipping_insurance_price: shipping_insurance_price / 100
  });
  


  if (v2?.id && !isGift) {
    data.push({
      id: v2.id,
      quantity: 1,
      selling_plan: v2?.selling_plan_allocations?.length ? v2.selling_plan_allocations[0].selling_plan_id : null,
      properties: {}
    });
  }

  if (v3?.id) {
    data.push({
      id: v3.id,
      quantity: 1,
      selling_plan: v3?.selling_plan_allocations?.length ? v3.selling_plan_allocations[0].selling_plan_id : null,
      properties: {}
    });
  }

  console.log("payloadddDta>>", data, {id:v1.id,url:v1.featured_image})

  if(v1.featured_image) {
    $('.step_2_list_item:has(input:checked) img.product_item_image').attr({ src: v1.featured_image.src, srcset: `${v1.featured_image.src.replace('.jpg','_300x.jpg')} 300w, ${v1.featured_image.src.replace('.jpg','_600x.jpg')} 600w, ${v1.featured_image.src.replace('.jpg','_900x.jpg')} 900w` });
    $('.step_2_list_item:has(input:checked) img.product_item_image')
    .attr({
      src: v1.featured_image.src,
      srcset: `
        ${v1.featured_image.src.replace('.jpg', '_300x.jpg')} 300w,
        ${v1.featured_image.src.replace('.jpg', '_600x.jpg')} 600w,
        ${v1.featured_image.src.replace('.jpg', '_900x.jpg')} 900w
      `,
      sizes: '(max-width: 768px) 100vw, 600px'
    });
  }
  window.payload_data = data;
}

function compare_at_price(variant) {
  if (!variant) return 0;
  const compareAt = Number(variant.compare_at_price) || 0;
  const price = Number(variant.price) || 0;

  if (compareAt > price) {
    return compareAt;
  }
  return price;
}

async function multipleATC(data, $btn = null) {
  try {
    const items = data.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
      selling_plan: item.selling_plan
    }));
    const formData = { items };
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    const result = await response.json();
    // console.log(result, "<<<<resutlt");
    $btn && $btn.removeClass('btn-loading');
    if (!response.ok) {
      $('.err-mgs').addClass('active').find('[data-error]').html(result.description);
      setTimeout(() => {
        $('.err-mgs').removeClass('active').find('[data-error]').html("");
      }, 1500);
    }
  } catch (error) {
    console.error("Error adding items:", error);
    $btn && $btn.removeClass('btn-loading');
  }
}

function isGiftSelected() {
  const isGift = $('[name="step_1"]:checked').val() === '2' ? true : false;
  return isGift;
}

function inputValidate() {
  if(!isGiftSelected()) return true;
  let validate = true;
  $('.subscription-box--section [required]').removeClass('error')
  $('.subscription-box--section [required]').each(function(){
    if($(this).val() == "") {
      $(this).focus().addClass('error');
      validate = false;
    }
  });
  return validate;
}

const updateStepCount = () => {
  $('.step_wrapper:visible .countt').each((index, element) => {
    $(element).html(`${index + 1}. `);
  });
};
